import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    properties: {
        phone: string;
        name: string;
        email: string;
        urgencyOfResolution: string;
        serialNumber: string;
    };
}>;

export const xDispatchUpdateRequestRma: HandlerType = props => {
    props.dispatch({
        ...props.parameter,
        type: "xRequestRma/updateRequestRma",
    } as any);
};

export const chain = [xDispatchUpdateRequestRma];

const xUpdateRequestRma = createHandlerChainRunner(chain, "xUpdateRequestRma");
export default xUpdateRequestRma;
